import React from 'react'
import Page from "../Page";
import { Link } from "react-router-dom";

class SyaratKetentuan extends Page {

   render() {
      return(
         <div className="bg-white no-shadow container pad-m">
            <div className="ml-s">
               <h4 className="select-wrapper mt-m" style={{ color:'black' }}>
                  Syarat dan Ketentuan Khusus Program Teman GETI Incubator:
               </h4>
                  <p 
                     className="mt-s"
                     style={{ 
                              color: "black", 
                              fontWeight: "100", 
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Syarat dan Ketentuan Khusus Program Teman GETI Incubator ("Syarat dan Ketentuan Khusus")<br/>ini merupakan perjanjian antara pemilik kode referral GeTI Incubator ("Anda" atau "Pemilik Kode") dan<br/>PT Global Edukasi Talenta Inkubater ("Kami" atau "GETI Incubator"), yaitu sebuah perseroan terbatas<br/>yang didirikan dan beroperasi secara sah berdasarkan hukum Negara<br/>Republik Indonesia dan berdomisili di DKI Jakarta, Indonesia.
                  </p>
                  <p 
                     className="mt-s"
                     style={{ 
                              color: "black", 
                              fontWeight: "100", 
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Syarat dan Ketentuan Khusus ini mengatur Anda saat menggunakan kode referral ("Program Teman<br/>GETI Incubator") pada aplikasi, situs web (www.geti.id dan situs web lain yang kami kelola),<br/>fitur, teknologi, konten dan produk yang Kami sediakan (selanjutnya, secara bersama-sama<br/>disebut sebagai "Platform")
                  </p>
                  <p 
                     className="mt-s"
                     style={{ 
                              color: "black", 
                              fontWeight: "100", 
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Syarat dan Ketentuan Khusus ini merupakan satu kesatuan dan bagian yang tidak terpisahkan dari<br/>
                     Syarat dan Ketentuan Umum Penggunaan Platform yang dapat diakses di<br/>
                     <b>www.geti.id ("Syarat dan Ketentuan Umum")</b> dan Kebijakan<br/>
                     Privasi yang dapat diakses di <b>www.geti.id ("Kebijakan Privasi").</b><br/>
                     Dengan berpartisipasi dalam Program Teman GETI Incubator, Anda akan dianggap telah membaca, <br/>
                     memahami, dan menyetujui Syarat dan Ketentuan Khusus ini.
                  </p>
                  <p 
                     className="mt-s"
                     style={{ 
                              color: "black", 
                              fontWeight: "100", 
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Harap membaca Syarat dan Ketentuan Khusus ini secara seksama sebelum Anda mulai mengikuti Pro- <br/>gram Teman GETI Incubator, karena peraturan ini<br/>
                     berlaku terhadap penggunaan kode referral Anda pada Platform Kami.
                  </p>
                  <p 
                     className="mt-s"
                     style={{ 
                              color: "black", 
                              fontWeight: "100", 
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Syarat dan Ketentuan Program Teman GETI Incubator
                  </p>
                  <div className="ml-0">
                     <ol>
                        <li style={{ 
                           color: "black",
                           lineHeight:"26px",
                           fontSize: "16",
                           }}
                        >
                           Promo diskon pada Program Teman GETI Incubator dapat digunakan berulang kali.
                        </li>
                        <li style={{ 
                           color: "black",
                           lineHeight:"26px",
                           fontSize: "16" 
                           }}
                        >
                           Mekanisme promo pada Program Teman GETI Incubator adalah sebagai berikut:
                        </li>
                           <div className="ml-s">
                              <ul>
                                 <li 
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Setiap akun di GETI Incubator akan memiliki kode referral Program Teman
                                    GETI Incubator ("Kode") yang dapat dibagikan kepada orang lain ("Pengguna Kode")
                                 </li>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Apabila Pemilik Kode berhasil menggundang Pengguna Kode untuk menggunakan 
                                    Kode saat menyelesaikan transaksi, Pemilik Kode akan mendapatkan benefit sesuai 
                                    ketentuan yang berlaku.
                                 </li>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Program Teman GETI Incubator tidak berlaku untuk pembelian kelas bertema CPNS 
                                    pada Platform.
                                 </li>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Kesalahan dalam pengisian data untuk pengiriman benefit bagi Pemilik Kode,
                                    bukan merupakan tanggung jawab tim GETI Incubator.
                                 </li>
                              </ul>
                           </div>
                        <li style={{ 
                           color: "black",
                           lineHeight:"26px",
                           fontSize: "16" 
                           }}
                        >
                           Benefit sebagaimana dimaksud pada poin (2) di atas akan direkapitulasi setiap akhir<br/>
                           minggu setelah pembelian kelas pelatihan oleh pengguna Kode telah terkonfirmasi oleh Kami.<br/>
                           Status pengiriman benefit akan diperbaharui setiap hari Senin di aplikasi masing-masing<br/>
                           Pemilik Kode. Benefit yang didapatkan merupakan akumulasi dari total transaksi dengan<br/> 
                           rentang 7 (tujuh) hari kalender dan akan dikirimkan paling lambat 7 (tujuh) hari kerja<br/>
                           kemudian.<br/>
                           Kuota maksimal benefit dan bonus transaksi yang dapat diklaim Pemilik Kode adalah sebesar<br/>
                           1.000 (seribu) transaksi per minggu, dan akan terhitung kembali dari nol pada minggu<br/>
                           berikutnya. Untuk menghindari keragu-raguan, sebagai contoh, apabila transaksi yang diklaim<br/>
                           menggunakan Kode sejumlah 1.500 (seribu lima ratus) transaksi dalam satu minggu,<br/>
                           maka benefit dan bonus atas kelebihan yang berjumlah 500 (lima ratus) transaksi tersebut<br/>
                           tidak dapat diklaim oleh Pemilik Kode dan tidak dapat terbawa ke minggu berikutnya.
                        </li>
                        <li style={{ 
                           color: "black",
                           lineHeight:"26px",
                           fontSize: "16" 
                           }}
                        >
                           Pengguna Kode wajib melakukan pembayaran dengan nominal yang sesuai hingga 3 digit<br/>
                           terakhir sesuai instruksi pembayaran dan tidak diperkenankan untuk melakukan klaim dalam<br/>
                           bentuk apapun, yang diantaranya termasuk namun tidak terbatas pada, penguangan kembali<br/>
                           (refund), penukaran paket, atau penukaran akun, atas pembelian kelas pelatihan oleh<br/>
                           Pengguna Kode di Platform.
                        </li>
                        <li style={{ 
                           color: "black",
                           lineHeight:"26px",
                           fontSize: "16" 
                           }}
                        >
                           Syarat untuk menjadi Pemilik Kode adalah sebagai berikut:
                        </li>
                        <div className="ml-s">
                              <ul>
                                 <li 
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Bukan merupakan dan/atau tidak sedang bekerja sebagai Aparatur Sipil Negara<br/>
                                    sebagaimana dimaksud Undang-Undang Nomor 5 Tahun 2014 tentang Aparatur Sipil<br/>
                                    Negara beserta peraturan perundang-undangan terkait lainnya;
                                 </li>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Bukan merupakan orang yang menerima gaji atau upah yang bersumber dari<br/>
                                    keuangan negara atau daerah;
                                 </li>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Bukan merupakan orang yang menerima gaji atau upah yang bersumber dari suatu<br/>
                                    korporasi yang menerima bantuan dari keuangan negara atau daerah; dan
                                 </li>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Bukan merupakan orang yang menerima gaji atau upah yang bersumber dari<br/>
                                    korporasi lain yang mempergunakan modal atau fasilitas dari negara atau<br/>
                                    masyarakat.
                                 </li>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Sebagai salah satu Lembaga Pelatihan pada program Kartu Prakerja yang<br/>
                                    diselenggarakan oleh Pemerintah Republik Indonesia, Kami memberikan kesempatan<br/>
                                    bagi Pemilik Kode untuk turut serta membagikan Kode kepada penerima manfaat<br/>
                                    Kartu Prakerja yang melakukan pembelian kelas pelatihan GETI Incubator di mitra<br/>
                                    Platform Digital pada program Kartu Prakerja (termasuk namun tidak terbatas pada<br/>
                                    Tokopedia, Bukalapak, dan Sekolahmu). Dalam hal Pemilik Kode membagikan Kode<br/>
                                    kepada penerima manfaat Kartu Prakerja, maka Pemilik Kode wajib mematuhi seluruh<br/>
                                    peraturan-peraturan, kebijakan-kebijakan, dan/atau tata tertib yang ditetapkan oleh<br/>
                                    Manajemen Pelaksana Kartu Prakerja (PMO) dan Kami turut menghimbau Pemilik<br/> 
                                    Kode untuk menunjukkan sikap dan perilaku yang menjunjung tinggi sopan santun<br/>
                                    selama berperan sebagai Pemilik Kode yang terdaftar pada Platform.
                                 </li>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Dalam hal Pemilik Kode membagikan Kode kepada penerima manfaat Kartu<br/>
                                    Prakerja sebagaimana dimaksud poin (6) di atas, maka Pemilik Kode dilarang:
                                 </li>
                                       <div className="ml-s">
                                          <li
                                             style={{ 
                                                listStyleType: "disc",
                                                color: "black",
                                                lineHeight:"26px",
                                                fontSize: "16" 
                                                }}
                                          >
                                             Menggunakan bahasa atau kalimat yang menggiring opini bahwa kelas<br/>
                                             pelatihan pada program Kartu Prakerja seolah-olah dapat cepat<br/>
                                             diselesaikan, terkesan mudah, tidak bermanfaat, dan lain sebagainya, dalam<br/>
                                             setiap kegiatan kampanye pemasaran dan promosi kelas pelatihan<br/>
                                             GETI Incubator yang melibatkan Pemilik Kode;
                                          </li>
                                          <li
                                             style={{ 
                                                listStyleType: "disc",
                                                color: "black",
                                                lineHeight:"26px",
                                                fontSize: "16" 
                                                }}
                                          >
                                             Menyebarluaskan kunci jawaban kelas pelatihan GETI Incubator (termasuk<br/>
                                             namun tidak terbatas pada kunci jawaban soal kuis, mid-test, atau post-test<br/>
                                             kelas pelatihan GETI Incubator); dan
                                          </li>
                                          <li
                                             style={{ 
                                                listStyleType: "disc",
                                                color: "black",
                                                lineHeight:"26px",
                                                fontSize: "16" 
                                                }}
                                          >
                                             Menimbulkan persepsi kepada publik bahwa pelaksana promosi kelas<br/> 
                                             pelatihan GETI Incubator melalui Program Teman GETI Incubator adalah<br/> 
                                             PMO Kartu Prakerja; dengan demikian, dalam setiap kegiatan promosi yang<br/>
                                             dilakukan oleh Pemilik Kode, penempatan nama "Kartu Prakerja" harus<br/> 
                                             diletakkan setelah nama "GETI Incubator".
                                          </li>
                                       </div>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Anda bertanggung jawab secara penuh atas setiap kerugian dan/atau klaim yang<br/> 
                                    timbul dari penggunaan Program Teman GETI Incubator melalui Akun Anda, baik oleh<br/>
                                    Anda atau pihak lain yang menggunakan Akun Anda, dengan cara yang<br/> 
                                    bertentangan dengan Syarat dan Ketentuan Khusus ini, Syarat dan Ketentuan Umum,<br/> 
                                    Kebijakan Privasi atau peraturan perundang-undangan yang berlaku, termasuk namun<br/>
                                    tidak terbatas untuk tujuan anti-korupsi, anti pencucian uang, anti pendanaan<br/> 
                                    terorisme, aktivitas kriminal, penipuan dalam bentuk apapun (termasuk namun tidak<br/> 
                                    terbatas pada kegiatan phishing dan/atau social engineering), pelanggaran hak<br/> 
                                    kekayaan intelektual, dan/atau aktivitas lain yang merugikan publik dan/atau pihak<br/> 
                                    lain manapun atau yang dapat atau dianggap dapat merusak reputasi Kami.
                                 </li>
                                 <li
                                    style={{ 
                                       listStyleType: "disc",
                                       color: "black",
                                       lineHeight:"26px",
                                       fontSize: "16" 
                                       }}
                                 >
                                    Seluruh data dan informasi pada Program Teman GETI Incubator yang dibagikan<br/>  
                                    oleh Kami kepada Pengguna dan Pemilik Kode bersifat rahasia. Pengguna dan Pemilik<br/>  
                                    Kode dilarang membagikan informasi dan data tersebut kepada pihak ketiga.
                                 </li>
                              </ul>
                           </div>
                     </ol>
                  </div>
               <h5>Syarat dan Ketentuan Lainnya</h5>
               <ol>
                  <li 
                     style={{ 
                              color: "black",
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Ketentuan lain dalam Syarat dan Ketentuan Umum dan Kebijakan Privasi yang tidak diubah<br/>
                     oleh Syarat dan Ketentuan Khusus ini akan tetap berlaku sepanjang tidak bertentangan<br/> 
                     dan/atau diatur secara khusus oleh Syarat dan Ketentuan Khusus ini.
                  </li>
                  <li 
                     style={{ 
                              color: "black",
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Dalam hal terdapat pertentangan antara ketentuan dalam Syarat dan Ketentuan Umum<br/> 
                     dan Kebijakan Privasi dengan ketentuan dalam Syarat dan Ketentuan Khusus ini, maka yang<br/> 
                     berlaku adalah Syarat dan Ketentuan Khusus ini.
                  </li>
                  <li 
                     style={{ 
                              color: "black",
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Kami memiliki hak untuk membekukan dan/atau menghapus akun Pengguna yang Kami<br/> 
                     anggap melanggar ketentuan yang terkandung dalam Syarat dan Ketentuan Umum dan/atau<br/> 
                     Syarat dan Ketentuan Khusus ini.
                  </li>
                  <li 
                     style={{ 
                              color: "black",
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Kami dapat mengubah Syarat dan Ketentuan Khusus ini dari waktu ke waktu, perubahan<br/> 
                     mana akan diberitahukan kepada Anda dalam bentuk dan melalui sarana apapun, termasuk<br/> 
                     namun tidak terbatas pada pemberitahuan melalui e-mail; dan Anda setuju bahwa Anda ber<br/> 
                     tanggung jawab untuk meninjau Syarat dan Ketentuan Khusus ini secara berkala. Penggunaan<br/> 
                     secara berkelanjutan oleh Anda atas Program Teman GETI Incubator setelah perubahan<br/> 
                     dan/atau penambahan Syarat dan Ketentuan Khusus yang berlaku, akan dianggap sebagai<br/> 
                     persetujuan dan penerimaan Anda atas perubahan dan/atau penambahan tersebut.
                  </li>
                  <li 
                     style={{ 
                              color: "black",
                              lineHeight:"26px",
                              fontSize: "16" 
                           }}
                  >
                     Apabila terdapat kendala/keluhan pada saat berpartisipasi dalam Program Teman GETI<br/> 
                     Incubator, atau Anda memiliki pertanyaan mengenai Syarat dan Ketentuan Khusus ini, Anda<br/> 
                     dapat menghubungi Kami dengan mengirimkan surat elektronik ke alamat campus.hq@geti.id<br/> 
                     atau pesan singkat WA ke nomor 08119 309 114
                  </li>
               </ol>
               <h5 className="mt-xl pb-l">Saya telah membaca Syarat dan Ketentuan Khusus ini dan mengerti isi dan konsekuensinya dan dengan ini menerima setiap hak, kewajiban, dan peraturan yang diatur di dalamnya.</h5>
            </div>
         </div>
      )
   }
}
export default SyaratKetentuan;


// WEBPACK FOOTER //
// ./src/components/Referral/SyaratKetentuan.js